goog.module('yext.fields.FieldView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Field = goog.require('yext.Field');
const notify = goog.require('yext.notify');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * FieldView handles all of the interactions for a field (e.g. toggle between view/edit modes)
 * and provides a simple interface for handling custom field validation and renderings of itself.
 * It also handles the communication between the server for the edit mode.
 *
 * @param {string} name The class name for the root node of the HTML element.
 *
 * e.g. Complex Fields
 * var inStoreCouponView = new FieldView('inStoreCoupon');
 * inStoreCouponView
 *  .setValidation(function($form) { ... })
 *  .setRender(function(data) { ... })
 *  .setRenderError(function(response) { ... });
 * @constructor
 */
const FieldView = function(name) {
  if (!yext.isString(name)) {
    throw new TypeError('Could not initialize field row on invalid field name');
  }

  // TODO(billy) Maybe this should take in an `id` that links to the actual proto id?
  // or it should parse it from the DOM
  this.name = name;
  this.showProgressDialog = true;
  this.$this = $(this);
  this.$ctx = $('.js-field-view-' + name +',.js-field-view[data-field-name="' + name + '"]').closest('.editable');
  this.$viewMode = this.$ctx.find('.js-view-mode');
  this.$editMode = this.$ctx.find('.js-edit-mode');

  this.field = {}; // @type Field
};

/**
 * Map of Constants based on the xoneprofile UpdateStatus proto message values.
 */
FieldView.prototype.errorCodes = {
  FAILURE: 2,
  STALE_UPDATE: 3,
};

/**
 * init will setup the initial state of the view and all of it's interactions
 */
FieldView.prototype.init = function() {
  this.field = new Field(this.$editMode.find('form'), {
    onSaveProgressDialog: this.showProgressDialog,
  });

  this.bindToggleEdit();
  this.bindFieldHandlers();
};

/**
 * bindToggleEdit handles the interaction between showing the view mode and edit mode.
 */
FieldView.prototype.bindToggleEdit = function() {
  var fieldView_ = this;
  this.$ctx.on('click', function() {
    if (!fieldView_.$viewMode.is(':visible')) {
      return;
    }

    fieldView_.$ctx.addClass('edit-mode');
    fieldView_.$viewMode.hide();
    fieldView_.$editMode.show();

    fieldView_.$this.trigger('startEditMode');
  });
};

/**
 * bindFieldHandlers is a convenience helper that handles initializing all of our bindings for our
 * field view.
 * e.g. Toggle edit/view mode, saving, resetting, etc.
 */
FieldView.prototype.bindFieldHandlers = function() {
  this.bindSaveField();
  this.bindResetField();
  this.bindInputChange();
};

/**
 * bindInputChange handles enabling and disabling the submit button based on the input fields
 * in the form that change, using a validation hook.
 */
FieldView.prototype.bindInputChange = function() {
  var fieldView_ = this;

  this.field.$form.find('input,textarea,select').inputchange(function() {
    if (fieldView_.validate(fieldView_.field.$form)) {
      fieldView_.field.enableSubmit();
    } else {
      fieldView_.field.disableSubmit();
    }
  });
};

/**
 * bindResetField handles when a user cancels editing a field.
 */
FieldView.prototype.bindResetField = function() {
  var fieldView_ = this;

  this.field.$form.on('reset.field', function() {
    fieldView_.$ctx.removeClass('edit-mode');
    fieldView_.$viewMode.show();
    fieldView_.$editMode.hide();
    fieldView_.field.disableSubmit();
    fieldView_.hideError();
    fieldView_.broadcastReset();
  });
};

/**
 * bindSaveField handles when a user submits the field to be saved, and handles the messages
 * from the server (success or errors).
 */
FieldView.prototype.bindSaveField = function() {
  var fieldView_ = this;

  this.field.$form.on('save.field', function(e, response) {
    if (yext.isObject(response.error) && yext.isNumber(response.error.statusCode)) {
      // We handle stale updates by re-rendering the view with the proper content
      // and opening back up the edit mode with the rendered error message.
      if (response.error.statusCode === fieldView_.errorCodes.STALE_UPDATE) {
        fieldView_.render(response.html);
        fieldView_.$ctx.trigger('click');
      }

      fieldView_.renderError(response.error);
      return;
    }

    fieldView_.render(response);
    $(fieldView_).trigger('viewUpdated');
  });

  this.field.$form.on('error.field', function(e, response) {
    fieldView_.networkError(response);
  });
};

/**
 * render is a default callback that handles injecting data into the views root context node.
 * Generally this method is called when user saves the field to the server and the visualization
 * needs to be updated. It can be customized via the setRender() api.
 * @param response The response from the server
 */
FieldView.prototype.render = function(response) {
  this.$ctx
    .removeClass('edit-mode')
    .find('.js-field-mode-wrap').html(response.html);

  this.field = new Field(this.$ctx.find('form'), {
    onSaveProgressDialog: this.showProgressDialog,
  });

  this.$viewMode = this.$ctx.find('.js-view-mode');
  this.$editMode = this.$ctx.find('.js-edit-mode');
  this.bindFieldHandlers();
  $(this).trigger('viewRendered');
};

/**
 * validate is the default behavior of a field, all field views have no validation,
 * but it can be customized by using the setValidation() api.
 */
FieldView.prototype.validate = function() {
  return true;
};

/**
 * Broadcasts all the triggers associated with resetting the field.
 */
FieldView.prototype.broadcastReset = function() {
  $(this).trigger('resetSpecification');
};


/**
 * networkError is the default behavior for when the field has trouble communicating with the server
 * for any reason (server exception, network error, etc).
 */
FieldView.prototype.networkError = function(response) {
  var err = response.error;
  if (!yext.isString(err)) {
    err = yext.msg('There was a problem with your request. Please reload the page and try again.');
  }

  notify.showError(err);
};

/**
 * renderError will handle structured error messages sent from the server (e.g. perhaps the
 * server field validation detected a problem).
 */
FieldView.prototype.renderError = function(response) {
  this.$editMode
    .find('.js-error-msg')
    .html(response.msg)
    .show();
};

/**
 * hideError will hide error messages in view.
 */
FieldView.prototype.hideError = function() {
  this.$editMode
    .find('.js-error-msg')
    .hide();
};

/**
 * setRender allows you to override the views rendering function. You generally want to customize
 * this if the servers sends a different data format to the client than what's expected.
 */
FieldView.prototype.setRender = function(fn) {
  if (!yext.isFunction(fn)) {
    throw new TypeError('FieldView: Invalid render type, could not set for field: ' + this.name);
  }
  this.render_ = this.render;
  this.render = fn;
  return this;
};

/**
 * setRenderError allows you to override the views error rendering function. You generally want to customize
 * this if the servers sends a different data format to the client than what's expected.
 */
FieldView.prototype.setRenderError = function(fn) {
  if (!yext.isFunction(fn)) {
    throw new TypeError('FieldView: Invalid render type, could not set for field: ' + this.name);
  }
  this.renderError_ = this.renderError;
  this.renderError = fn;
  return this;
};

/**
 * setValidation allows you to provide custom validation for your form. Your function should return
 * true or false to tell the FieldView to either disable or enable the submit button.
 */
FieldView.prototype.setValidation = function(fn) {
  if (!yext.isFunction(fn)) {
    throw new TypeError('FieldView: Invalid validation type, could not set for field: ' + this.name);
  }
  this.field.setValidator(fn);
  this.validate_ = this.validate;
  this.validate = fn;
  return this;
};

/**
 * on is a jQuery wrapper that allows you to hook into event handlers easily
 */
FieldView.prototype.on = function(eventName, cb) {
  if (!yext.isString(eventName)) {
    throw new TypeError('FieldView: eventName must be of type `string`');
  }

  if (!yext.isFunction(cb)) {
    throw new TypeError('FieldView: callback must be of type `function`.');
  }

  this.$this.on(eventName, cb);
  return this;
};

exports = FieldView;
